module.exports = __webpack_public_path__ + "img/Error.c5cb03be.svg";